const DISCONTINUED_SERVICE = 'discontinuedService';

export default DISCONTINUED_SERVICE;
